import { NewCurrenciesComponent } from "./new-currencies.component";
import { connect } from 'react-redux'
import { Currencies } from "@components/currencies";
import withStyles from '@material-ui/core/styles/withStyles';
import combineStyles from '~/utils/styles';
import form from '@style/form'
import modal from '@style/modal'

const mapStateToProps = (state, props) => ({});

const actions = {
    updateCurrency: Currencies.actions.updateCurrency,
};

export const NewCurrenciesContainer = connect(mapStateToProps, actions)(withStyles(combineStyles(form, modal))(NewCurrenciesComponent));
